import React from 'react';
import styles from './Image.styl';

class Image extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			allScreen: false
		}
	}


	render() {
		const className = `${this.props.className ? this.props.className : styles.img} ${this.props.url ? '' : (this.props.noPhotoSmall ? styles.imgNoPhoto110 : styles.imgNoPhoto)}`;
		const style = this.props.url ? {backgroundImage: `url(${this.props.url})`, backgroundSize:'contain'} : {backgroundSize:'contain'};
		return (

			this.props.blockChangeScale
				?
				<div className={className} style={style}></div>
				:
				<React.Fragment>
					{
						this.state.allScreen
							? <div  onClick={()=>this.setState({allScreen:false})} className={styles.allScreen}><div className={className} style={style}></div></div>
							: <div className={className} style={style} onClick={()=>this.setState({allScreen:true})}></div>
					}
				</React.Fragment>
		);
	}
}

export default Image;



// WEBPACK FOOTER //
// ./src/react/ui/features/Image.jsx